import gql from "graphql-tag";

export default gql`
  mutation LoginWithCredentials(
    $email: String!
    $password: String!
    $timeZone: String!
    $turnstileToken: String!
    $turnstileIdempotencyKey: String
  ) {
    loginWithCredentials(
      email: $email
      password: $password
      timeZone: $timeZone
      turnstileToken: $turnstileToken
      turnstileIdempotencyKey: $turnstileIdempotencyKey
    ) {
      email
      isRecentlyCreatedUser
      accessToken
    }
  }
`;
